import { render, staticRenderFns } from "./NationalityInput.vue?vue&type=template&id=099fa74d&scoped=true"
import script from "./NationalityInput.vue?vue&type=script&lang=ts"
export * from "./NationalityInput.vue?vue&type=script&lang=ts"
import style0 from "./NationalityInput.vue?vue&type=style&index=0&id=099fa74d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099fa74d",
  null
  
)

export default component.exports